import { useState, useEffect } from 'react';
import {
    getManageEnvelopeList,
    getDocuments,
    // showMyFiles,
    // myFilesFolderView
} from "../../../../services/CommonService";

const useDocumentCounts = ({ userEmail, selectedUserId, dataParams, userId }) => {
    const [counts, setCounts] = useState({
        totalMyFile: 0,
        totalFiles: 0,
        totalInProgress: 0,
        totalDraft: 0,
        totalCompleted: 0,
    });
    const [envelopeList, setEnvelopeList] = useState([]);
    const [envelopeProcess, setEnvelopeProcess] = useState('loading...');
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(false);

    // API 1: getManageEnvelopeList for totalInProgress, totalDraft, totalCompleted
    useEffect(() => {
        setEnvelopeList([]);
        setEnvelopeProcess('loading...');
        getManageEnvelopeList(dataParams)
            .then(response => {
                setEnvelopeList(response.data.data);
                if (response.data.data.length === 0) setEnvelopeProcess('No data available.');
                if (response.data.status_count.length > 0) {
                    setCounts(prev => ({
                        ...prev,
                        totalInProgress: parseInt(response.data.status_count[0] || 0),
                        totalDraft: parseInt(response.data.status_count[1] || 0),
                        totalCompleted: parseInt(response.data.status_count[2] || 0),
                    }));
                }
            })
            .catch(() => {
                setEnvelopeProcess('No data available.');
                setCounts(prev => ({
                    ...prev,
                    totalInProgress: 0,
                    totalDraft: 0,
                    totalCompleted: 0,
                }));
            });
    }, [dataParams, userId]);

    // API 2: getDocuments for totalFiles
    useEffect(() => {
        if (!userEmail) return;
        setLoading(true);
        getDocuments({ email: userEmail })
            .then(response => {
                if (response?.data?.data) {
                    setDocuments(response.data.data.map(doc => ({ ...doc, tags: doc.tags || [] })));
                    setCounts(prev => ({
                        ...prev,
                        totalFiles: response.data.count || 0,
                    }));
                }
            })
            .catch(() => {
                setDocuments([]);
                setCounts(prev => ({
                    ...prev,
                    totalFiles: 0,
                }));
            })
            .finally(() => setLoading(false));
    }, [userEmail]);

    // API 3:  for totalMyFile
    // useEffect(() => {
    //     if (!selectedUserId) return;
    //     myFilesFolderView(selectedUserId)
    //         .then(response => {
    //             setCounts(prev => ({
    //                 ...prev,
    //                 totalMyFile: response.data.count || 0,
    //             }));
    //         })
    //         .catch(() => {
    //             setCounts(prev => ({
    //                 ...prev,
    //                 totalMyFile: 0,
    //             }));
    //         });
    // }, [selectedUserId]);

    return {
        counts,
        envelopeList,
        envelopeProcess,
        documents,
        loading,
        setLoading, 
        setCounts,
        setEnvelopeList,
        setEnvelopeProcess,
        setDocuments
    };
};

export default useDocumentCounts;